import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { useMemberToolbarDisplaying } from "Flocknote/stateHooks";

import useIsLoginActive from "Login/TwoFA/useIsLoginActive";

import { useMemberToobarContext } from "./MemberToolbarState";
import { contentKeys } from "./contentKeys";

const useIsLoginDisabled = () => {
  const [isLoginActive] = useIsLoginActive();
  const { activeContentKey } = useMemberToobarContext();

  if (activeContentKey === "login") return false;
  return isLoginActive;
};

const useHasActiveContent = () => {
  const { activeContentKey } = useMemberToobarContext();

  const hasActiveContent = useMemo(
    () => activeContentKey !== "nothing",
    [activeContentKey]
  );

  return hasActiveContent;
};

const useEscapeAction = () => {
  const {
    activeContentKey,
    contactButtonRef,
    loginButtonRef,
    userButtonRef,
    backButtonRef,
  } = useMemberToobarContext();
  return useCallback(() => {
    switch (activeContentKey) {
      case contentKeys.login:
        loginButtonRef.current.click();
        loginButtonRef.current.focus();
        return;
      case contentKeys.user:
        userButtonRef.current.click();
        userButtonRef.current.focus();
        return;
      case contentKeys.form:
        backButtonRef.current.click();
        backButtonRef.current.focus();
        return;
      case contentKeys.contact:
      case contentKeys.messageSent:
        contactButtonRef.current.click();
        contactButtonRef.current.focus();
        return;
      default:
        return;
    }
  }, [
    activeContentKey,
    contactButtonRef,
    loginButtonRef,
    userButtonRef,
    backButtonRef,
  ]);
};

const useShowMemberToolbar = () => {
  const [memberToolbarDisplaying, setMemberToolbarDisplaying] =
    useMemberToolbarDisplaying();
  const [oneWasAlreadyDisplaying] = useState(memberToolbarDisplaying); // static by design. If there was already one before this happen, don't show. Ever.

  useEffect(() => {
    setMemberToolbarDisplaying(true);
    return () => {
      if (!oneWasAlreadyDisplaying) setMemberToolbarDisplaying(false);
    };
  }, [setMemberToolbarDisplaying, oneWasAlreadyDisplaying]);

  const { isIniting } = useMemberToobarContext();

  return useMemo(() => {
    if (oneWasAlreadyDisplaying) return false;
    if (isIniting) return false;
    return true;
  }, [isIniting, oneWasAlreadyDisplaying]);
};

export {
  useIsLoginDisabled,
  useHasActiveContent,
  useEscapeAction,
  useShowMemberToolbar,
};
